import { render, staticRenderFns } from "./donate-programs.vue?vue&type=template&id=503153ec&scoped=true"
import script from "./donate-programs.vue?vue&type=script&lang=js"
export * from "./donate-programs.vue?vue&type=script&lang=js"
import style0 from "./donate-programs.vue?vue&type=style&index=0&id=503153ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503153ec",
  null
  
)

export default component.exports